import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Input, Modal, ModalBody, ModalHeader } from 'reactstrap'

import { UPDATE_GOLF_BOOKING , SEND_MAIL} from '../../../../store/application/actionType'
import moment from 'moment'

const UpdateModal = ({ data, onCloseHandler }) => {
  console.log('sdsd',data)
  const dispatch = useDispatch()

  const initialObj = {
    teetime: data ? moment(data[14],'hh:mm:ss A').format('HH:mm'):''
  }
  const [modal_varying1, setmodal_varying1] = useState(true)
  const [inputData, setInputData] = useState(initialObj)

  const [modalData, setModalData] = useState(null)

  useEffect(() => {
    if (data !== null) {
      setModalData(data)
    }
  }, [data])

    /* ---------------------------- INPUT CHANGE HANDLER ---------------------------- */
    const inputChangeHandler = (e) => {
      const { name, value } = e.target
      setInputData({ ...inputData, [name]: value })
      // switch (name) {
      //   case 'teetime':
          
      //     break
  
      //   default:
      //   // do nothing
      // }
    }
  const bookingUpdateHanlder = () => {
    onCloseHandler(false)
    setmodal_varying1(!modal_varying1)
    const bookingData=data[19]
    let teetimeModifyHistoryArray = bookingData?.teetimeModifyHistory ?? []
    if(teetimeModifyHistoryArray.length >=3){
      alert('Teetime cannot be ammended more than 3 times.')
      return false;
    } 
   
    const user=JSON.parse(sessionStorage.getItem('authUser'))
   
    let teetimeModifyHistoryObject={
      
      "modifiedBy": user?.data?.data?.username,
      "teetime": inputData?.teetime,
      "modifiedAt": new Date().toISOString(),
      
    }
    teetimeModifyHistoryArray.push(teetimeModifyHistoryObject)
   
    // console.log('teeetime-->', teetimeModifyHistoryArray)
    // return false;
  
    dispatch({
      type: UPDATE_GOLF_BOOKING,
      payload: {
        bookingId: bookingData?.objectId,
        payloadData: {
          time_of_play: {
            preferred: inputData.teetime,
          },
          teetimeModifyHistory:teetimeModifyHistoryArray
          
        },
      },
    });
    //  const mailPayload = {
    //         userId: bookingData?.user?.id,
    //         bookingId: bookingData?.objectId,
    //         templateCode: "email_05", // this code is for confirm email template ,change for teetime update template
    //         emailId: bookingData?.user?.email,
    //       };
    
    //       dispatch({
    //         type: SEND_MAIL,
    //         payload: {
    //           payloadData: mailPayload,
    //         },
    //       });
  }

  const tog_varying1 = () => {
    onCloseHandler(false)
    setmodal_varying1(!modal_varying1)
  }

  return (
    <Modal
      isOpen={modal_varying1}
      toggle={() => {
        tog_varying1()
      }}
      id="exampleModal"
    >
      <ModalHeader
        toggle={() => {
          tog_varying1()
        }}
      >
        Booking Update
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="mb-3 d-none">
            <label htmlFor="customer-name" className="col-form-label">
              Confirmed GC
            </label>
            <select
              className="form-select"
              name="projectName"
              // value={filter.projectName}
              // onChange={inputChangeHandler}
            >
              <option value="">Choose...</option>
              <option value="Pending">Pending</option>
              <option value="Process">Process</option>
              <option value="Confirmed">Confirmed</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>
          <div className="mb-3 d-none">
            <label htmlFor="message-text" className="col-form-label">
              Confirmed DOP
            </label>
            <Input
              type="date"
              className="form-control"
              id="customer-name"
              value=""
            />
          </div>
          <div className="mb-3">
            <label htmlFor="message-text" className="col-form-label">
              Confirmed Tee Time
            </label>
            <Input
              type="time"
              className="form-control"
              id="teetime"
              name="teetime"
              value={inputData.teetime}
              onChange={inputChangeHandler}
            />
          </div>
          <div className="mb-3 d-none">
            <label htmlFor="message-text" className="col-form-label">
              Confirmed Number
            </label>
            <Input
              type="number"
              className="form-control"
              id="customer-name"
              value=""
            />
          </div>
        </form>
      </ModalBody>
      <div className="modal-footer d-flex justify-content-center">
        <Button color="primary" onClick={bookingUpdateHanlder}>
          Submit
        </Button>
      </div>
    </Modal>
  )
}

export default UpdateModal
